
import { pxToEm } from '@insticator/insticator-ui';

export default {
    apiAccess : {
        '& .sectioncard' : {
            '& .sectiongroup': {
                display: 'flex',
                flexDirection: 'row',
                gap: pxToEm(16),
                '& > h2': {
                    fontSize: '1em',
                    minWidth: '9.375em',
                    fontWeight: '700',
                    lineHeight: '1.5em',
                }
            },

        }},
    titleHeader : {
        display : 'flex',
        flexDirection : 'row',
        gap : pxToEm(16)
    },
    enableApiAccess : {
        display : 'flex',
        flexDirection : 'row',
        gap : pxToEm(16)

    },
    sectionGroup : {
        marginTop: '2em !important',
    },
    enableApiAccessDescription : {
        fontSize: '1em',
        minWidth: '9.375em',
        lineHeight: '1.5em',
    },
    apiaccesssection : {
        '& .configv2controller' : {
            '& .actions' : {
                '& .toggleicons': {
                    display: 'none !important',
                }
            }
        },
        '& .opened' : {
            marginTop: pxToEm(-32),
            '& .innerWrap' : {
                padding: '1em !important',
                '& .sectioncta' : {
                }
            }
        },
        '& .configtoggle' : {
            paddingTop: pxToEm(24),
            paddingBottom: pxToEm(24),
            paddingLeft: pxToEm(24)
        }
    },
    apiAccessSection : {
        backgroundColor: 'transparent',
    },
    expandableSection : {
        '& >.content':{
            '& > .copyfield' : {
                display: 'flex',
                flexDirection: 'row',
                maxWidth : pxToEm(535),
                width : '100%',
                '& > .field' : {
                    marginRight:'0.75em',
                    '& > .formelement' :{
                        maxWidth: pxToEm(448),
                        width: '100%',
                        backgroundColor: '#FAFBFC',
                        border: '1px solid #F2F4F8',
                        '& > .element' :{
                            '& > [name="apiKey"]' :{
                                'text-security' : 'disc',
                            }
                        }
                    }
                },
                '& > .buttonlink' : {
                    '& > .ctas' : {
                        '& > .name-copycta' : {
                            padding: '0em 1em',
                        }

                    }
                }
            },
            '& > .section' : {
                marginTop : pxToEm(8), marginBottom : pxToEm(8),
                display: 'flex',
                flexDirection: 'row',
                gap: '0.75em',
                '& > .variant-action' : {
                    backgroundColor: '#DF1D1D',
                    color : '#FFFFFF !important',
                },
                '& > .name-enableCreation':{
                    backgroundColor: '#061240',
                    cursor: 'pointer',
                },
                '& > .variant-normal' : {
                    border : '1px solid #061240',
                    '& > .icon' : {
                        '& > .fa-book':{
                            height : pxToEm(18),
                            width : pxToEm(18)
                        }
                    }
                }

            },
        },

    },
    eyeIcon:{
        position: 'relative',
        zIndex: '2',
        right: '132px',
        top: '13px',
        color: '#AEB6D6'
    },
    fieldLabel : {
        fontWeight: 400,
        fontSize : pxToEm(14),
        lineHeight : pxToEm(18),
        marginBottom: pxToEm(-5),
    },
    vertical : {
        height: '100%',
        float: 'left',
        backgroundColor: '#AEB6D6',
    },


};